import { createSvgIconComponent } from "../utils";
export var IconClock = createSvgIconComponent({
  path: "M10 0a10 10 0 1 0 10 10A10.016 10.016 0 0 0 10 0Zm3.71 13.71a1.014 1.014 0 0 1-1.42 0l-3-3A1.033 1.033 0 0 1 9 10V5a1 1 0 0 1 2 0v4.59l2.71 2.7a1.008 1.008 0 0 1 0 1.42Z",
  fill: "currentColor",
  viewBox: "0 0 20 20"
});